// An email change needs two codes (#156): one sent to the new address and one
// sent to the address being replaced. These helpers keep that rule out of the
// profile view so it can be tested.

/**
 * The confirm-change request body. The current-address code is only sent when
 * the change needs one.
 * @param {string} code
 * @param {string} currentEmailCode
 * @param {string} currentEmail the address being replaced, or '' when the email isn't changing
 * @returns {{ code: string, current_email_code?: string }}
 */
export function confirmChangeBody(code, currentEmailCode, currentEmail) {
    if (!currentEmail) return { code };
    return { code, current_email_code: currentEmailCode };
}

/**
 * Whether every code the change needs has been entered.
 * @param {string} code
 * @param {string} currentEmailCode
 * @param {string} currentEmail
 * @returns {boolean}
 */
export function hasEveryCode(code, currentEmailCode, currentEmail) {
    if (code.length !== 6) return false;
    return !currentEmail || currentEmailCode.length === 6;
}

/**
 * The codes a confirm link carried. The new address's email links with
 * `code`, the current address's with `current_code`; either may be missing.
 * @param {string} search a location.search string
 * @returns {{ code: string, currentEmailCode: string }}
 */
export function codesFromConfirmLink(search) {
    const params = new URLSearchParams(search);
    return { code: params.get('code') || '', currentEmailCode: params.get('current_code') || '' };
}
